import "./FeesEnrollment.module.css";
import Navigation from "@/reusable_sections/Header";
import Tuition from "./sections/Tuition";
import Registration from "./sections/Registration";
import Application from "./sections/Application";
import Footer from "@/reusable_sections/Footer";
export default function FeesEnrollmentPage() {
  return <div>
      <Navigation />
      <Tuition />
      <Registration />
      <Application />
      <Footer />
    </div>;
}